import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { ToggleButton } from 'stories/components'

import { hardCodedEmailList } from './constants'

export const EmailsHardcoded = () => {
  const [isLoading, setLoading] = useState(false)
  const [isChanged, setChanged] = useState(false)
  const [data, setData] = useState<Record<string, boolean>>({})

  useEffect(() => {
    setLoading(true)
    getAdminConfig('emailHardcoded')
      .then((res) => setData(res))
      .finally(() => setLoading(false))
  }, [])

  const onChange = (key: string, value: boolean) => {
    const newData = cloneDeep(data)
    newData[key] = value
    setData(newData)
    setChanged(true)
  }

  const onSave = () => {
    setLoading(true)
    setAdminConfig('emailHardcoded', data)
      .then(() => toast('Configuration is stored successfully.', { type: 'info' }))
      .finally(() => {
        setLoading(false)
        setChanged(false)
      })
  }

  return (
    <div>
      <LayoutLoading show={isLoading} />
      <SaveChanges show={isChanged} onSave={onSave} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {Object.keys(hardCodedEmailList).map((key, index) => (
          <div key={key} className="mb-2">
            <ToggleButton
              id={key}
              title={`${index + 1}. ${hardCodedEmailList[key]}`}
              value={data[key] === false ? false : true}
              onChange={(value) => onChange(key, value)}
              textLeft
            />
          </div>
        ))}
      </div>
    </div>
  )
}
